import { Transfer } from 'antd';
import { Form } from '@bancobarigui/barihaus';

import { usePropertyTypesTransfer } from './usePropertyTypesTransfer';

export function PropertyTypesTransfer() {
  const { propertyTypes } = usePropertyTypesTransfer();

  return (
    <>
      <style>{`
        .property-types-transfer .ant-transfer-list {
          border-radius: 8px !important;
          border-color: #d6dbe7 !important;
        }
        .property-types-transfer .ant-transfer-list-search .ant-input,
        .property-types-transfer .ant-transfer-list-search.ant-input-affix-wrapper {
          border-radius: 8px !important;
          border-color: #d6dbe7 !important;
        }
      `}</style>
      <Form.Item
        name="propertyTypes"
        valuePropName="targetKeys"
        getValueFromEvent={(targetKeys) => targetKeys}
        rules={[{ required: true, message: 'Informe ao menos um Tipo de Imovel.' }]}
      >
        <Transfer
          className="property-types-transfer"
          listStyle={{
            width: '50%',
            height: 300,
          }}
          dataSource={propertyTypes}
          render={(item) => item.title ?? ''}
          titles={['Tipos de Imovel Disponíveis', 'Tipos de Imovel Selecionados']}
        />
      </Form.Item>
    </>
  );
}
